import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';

@Injectable()
export class RouteStopsActions {
    static FETCH_ROUTE_STOPS = '[Schedule]: Fetch routes stops';
    static FETCH_ROUTE_STOPS_SUCCESS = '[Schedule]: Fetch routes stops  successful';
    static FETCH_ROUTE_STOPS_FAIL = '[Schedule]: Fetch routes stops failed';

    static RESET_ROUTE_STOPS = '[Schedule]: Reset routes stops';

    static FETCH_ROUTE_POLYLINE = '[Schedule]: Fetch route polyline';
    static FETCH_ROUTE_POLYLINE_SUCCESS = '[Schedule]: Fetch route polyline successful';
    static FETCH_ROUTE_POLYLINE_FAIL = '[Schedule]: Fetch route polyline failed';

    static FETCH_ROUTE_STOP_DEPATURES = '[Schedule]: Fetch route stop departures';
    static FETCH_ROUTE_STOP_DEPATURES_SUCCESS = '[Schedule]: Fetch route stop departures successful';
    static FETCH_ROUTE_STOP_DEPATURES_FAIL = '[Schedule]: Fetch route stop departures failed';

    static SET_SELECTED_STOP = '[Schedule] Set selected stop';
    static SET_SELECTED_DAY = '[Schedule] Set selected day';

    fetchRouteStops(id): RidangoReduxAction {
        return {
            type: RouteStopsActions.FETCH_ROUTE_STOPS,
            payload: id,
        };
    }

    fetchRouteStopsSuccess(payload) {
        return {
            type: RouteStopsActions.FETCH_ROUTE_STOPS_SUCCESS,
            payload: payload,
        };
    }

    fetchRouteStopsFail() {
        return {
            type: RouteStopsActions.FETCH_ROUTE_STOPS_FAIL,
        };
    }

    resetRouteStops() {
        return {
            type: RouteStopsActions.RESET_ROUTE_STOPS,
        };
    }

    fetchRoutePolyline(id): RidangoReduxAction {
        return {
            type: RouteStopsActions.FETCH_ROUTE_POLYLINE,
            payload: id,
        };
    }

    fetchRoutePolylineSuccess(payload) {
        return {
            type: RouteStopsActions.FETCH_ROUTE_POLYLINE_SUCCESS,
            payload: payload,
        };
    }

    fetchRoutePolylineFail() {
        return {
            type: RouteStopsActions.FETCH_ROUTE_POLYLINE_FAIL,
        };
    }

    fetchRouteStopDepartures(payload): RidangoReduxAction {
        return {
            type: RouteStopsActions.FETCH_ROUTE_STOP_DEPATURES,
            payload: payload,
        };
    }

    fetchRouteStopDeparturesSuccess(payload) {
        return {
            type: RouteStopsActions.FETCH_ROUTE_STOP_DEPATURES_SUCCESS,
            payload: payload,
        };
    }

    fetchRouteStopDeparturesFail() {
        return {
            type: RouteStopsActions.FETCH_ROUTE_STOP_DEPATURES_FAIL,
        };
    }

    setSelectedStop(id) {
        return {
            type: RouteStopsActions.SET_SELECTED_STOP,
            payload: id,
        };
    }

    setSelectedDay(day) {
        return {
            type: RouteStopsActions.SET_SELECTED_DAY,
            payload: day
        }
    }
}
